export default [
    {
        path: 'relatorio-indicador-sad',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-indicador-sad' */
            '@/views/atencao-basica/relatorio-indicador-sad/Index'
        ),
        redirect: 'relatorio-indicador-sad/index',
        children: [
            {
                name: 'atencao-basica-relatorio-indicador-sad-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'atencao-basica-relatorio-indicador-sad' */
                    '@/views/atencao-basica/relatorio-indicador-sad/List.vue'
                ),
            },
        ],
    },
]